import '.d8{font-size:1.125rem;}.ssr-plugin'
import '.eb{line-height:1.75rem;}.ssr-plugin'
import '.hy{text-decoration:none;}.ssr-plugin'
import '.f2{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="d8 eb"
    >
      {translations.privacySubtitle}{' '}
      <a className="hy f2"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="hy f2"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
